"use client";

import React from "react";
import { motion, useReducedMotion } from "framer-motion";
export default function History() {
  const shouldReduceMotion = useReducedMotion();
  return <section id="ourhistory" data-nav="dark" className="relative w-full text-background py-16 px-4 overflow-hidden !bg-[rgba(0,0,0,1)] md:py-24 sm:px-6 lg:px-8 font-['Switzer',sans-serif]">
      <div className="max-w-4xl mx-auto flex flex-col items-center">
        
        {/* Contenido de texto centrado */}
        <motion.div initial={shouldReduceMotion ? {
        opacity: 1
      } : {
        opacity: 0,
        y: 16
      }} whileInView={shouldReduceMotion ? {
        opacity: 1
      } : {
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.1,
        ease: "easeOut"
      }} className="text-center max-w-3xl">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-normal tracking-tight text-background mb-6 font-['Switzer',sans-serif]">
            Nuestra historia
          </h2>

          <p className="text-base leading-relaxed text-muted font-['Switzer',sans-serif] !text-justify sm:text-lg">
            Las Asambleas de Dios tienen una historia vibrante de compartir el mensaje del
            Evangelio a nivel mundial. Ahora el Señor nos ha invitado a una nueva
            temporada. Se dio una exhortación profética en el Congreso Mundial de las
            Asambleas de Dios en 2017, pidiéndole al Señor de la Cosecha que nos ayude
            para que si Él tarda en su regreso hasta 2033, la Comunión de las Asambleas
            de Dios Mundiales esté compuesta por ¡UN MILLÓN de iglesias! Estamos
            buscando la guía del Señor y construyendo Su Iglesia mientras fomentamos el
            avivamiento entre las naciones.
          </p>
        </motion.div>
        
      </div>
    </section>;
}